<template>
  <span>{{ timeAgo }}</span>
</template>

<script>
import moment from 'moment';
import EcsAgentStatsMath from '@/components/ecs-agent-stats/EcsAgentStats.math';

export default {
  name: 'EcsLiveTimeAgo',

  props: {
    since: {
      type: String,
      default: '',
      examples: ['2021-02-01T12:30:40.452+00:00', '00:12:35.65433']
    },
    shortOutput: {
      type: Boolean,
      default: false
    },
    verbose: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      timerReference: null,
      timeAgo: '',
      startFrom: null
    };
  },

  computed: {
    isValidDate() {
      return new Date(this.since).toString() !== 'Invalid Date';
    }
  },

  watch: {
    since() {
      this.lastUpdate = moment();
      this.timeDiff();
    }
  },

  created() {
    this.computeTime();
    this.lastUpdate = moment();
  },

  beforeDestroy() {
    clearInterval(this.intervalReference);
  },

  methods: {
    timeDiff() {
      const now = moment();
      let duration;

      if (this.isValidDate) {
        duration = moment.duration(now.diff(moment(this.since)));
      } else {
        duration = moment.duration(this.since).add(moment.duration(now.diff(moment(this.lastUpdate))));
      }

      this.timeAgo = EcsAgentStatsMath.stringifyDuration(duration, this.verbose, this.shortOutput);
    },

    computeTime() {
      this.timeDiff();
      this.timerReference = setInterval(this.timeDiff, 1000);
    }
  }
};
</script>

<style scoped></style>
